import React, { useEffect } from "react";
import useToastStore from "store/useToastStore";
import _ from "lodash";
import { Button } from "components/button/Button/Button";
import { Icons } from "contents/icons";
import { LottieLoading } from "components/lottie/LottieLoading";

export const FixedToastWrap = () => {
  const {
    fixedToastType,
    fixedToastColor,
    fixedToastButton,
    fixedToastMessage,
    fixedToastLoadingMessage,
  } = useToastStore();

  return (
    <div className="content-box">
      <div className="title-box">
        {fixedToastType === "success" && <Icons.CheckCircle className="icon" />}
        {fixedToastType === "warning" && (
          <Icons.AlertTriangle className="icon" />
        )}
        {fixedToastType === "error" && <Icons.XCircle className="icon" />}
        {fixedToastType === "info" && <Icons.InfoCircle className="icon" />}
        {fixedToastType === "loading" && (
          <div className="loading">
            <LottieLoading size={16} padding="0.2rem" />
            {fixedToastLoadingMessage && <p>{fixedToastLoadingMessage}</p>}
          </div>
        )}
        {fixedToastType !== "loading" && (
          <p>
            {fixedToastType.charAt(0).toUpperCase() + fixedToastType.slice(1)}
          </p>
        )}
      </div>
      <p className="message">
        {fixedToastMessage.split("\n").map((message, index) =>
          index === 0 ? (
            <React.Fragment key={`${message}-${index}`}>
              {message}
            </React.Fragment>
          ) : (
            <React.Fragment key={`${message}-${index}`}>
              <br />
              {message}
            </React.Fragment>
          )
        )}
      </p>
      {fixedToastButton !== null && (
        <Button
          size="small"
          type="solid"
          preIcon={fixedToastButton.preIcon}
          postIcon={fixedToastButton.postIcon}
          color={
            fixedToastType === "info" || fixedToastType === "loading"
              ? fixedToastColor === "normal"
                ? "strong"
                : "normal"
              : "normal"
          }
          label={fixedToastButton.label}
          onClick={fixedToastButton.onClick}
        />
      )}
    </div>
  );
};
